import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ProfilePictureProvider } from './context/ProfilePictureContext';
import { Layout } from './components/layout/Layout';
import { ProtectedRoute } from './auth/ProtectedRoute';
import { HomePage } from './pages/HomePage';
import { PostPage } from './pages/PostPage';
import { CreatePostPage } from './pages/CreatePostPage';
import { EditPostPage } from './pages/EditPostPage';
import { ProfilePage } from './pages/ProfilePage';
import { LoginPage } from './pages/LoginPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { CallbackPage } from './pages/CallbackPage';
import { DeletedPostsPage } from './pages/DeletedPostsPage';
import { DeletedCommentsPage } from './pages/DeletedCommentsPage';
import { FlaggedPostsPage } from './pages/FlaggedPostsPage';
import { FlaggedCommentsPage } from './pages/FlaggedCommentsPage';
import { MessagesPage } from './pages/MessagesPage';
import { NotificationsPage } from './pages/NotificationsPage';
import { AdminModeratorsPage } from './pages/AdminModeratorsPage';
import { AdminUsersPage } from './pages/AdminUsersPage';
import { AdminStatisticsPage } from './pages/AdminStatisticsPage';
import {
  MissedConnectionsPage,
  AboutPage,
  SymbolPage,
  ShowSymbolPage,
  SignatureSongPage,
  ContactPage,
  FAQPage,
  HelpPage,
  CommunityRulesPage,
  TermsPage,
  PrivacyPage,
  ImprintPage,
} from './pages/static';

function App() {
  return (
    <BrowserRouter>
      <ProfilePictureProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/posts/:id" element={<PostPage />} />
          <Route path="/posts/new" element={<CreatePostPage />} />
          <Route
            path="/posts/:id/edit"
            element={
              <ProtectedRoute>
                <EditPostPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/messages"
            element={
              <ProtectedRoute>
                <MessagesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/notifications"
            element={
              <ProtectedRoute>
                <NotificationsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/moderation/deleted-posts"
            element={<DeletedPostsPage />}
          />
          <Route
            path="/moderation/deleted-comments"
            element={<DeletedCommentsPage />}
          />
          <Route
            path="/moderation/flagged-posts"
            element={<FlaggedPostsPage />}
          />
          <Route
            path="/moderation/flagged-comments"
            element={<FlaggedCommentsPage />}
          />
          <Route
            path="/moderation/flagged-comments"
            element={<FlaggedCommentsPage />}
          />
          <Route
            path="/administration/moderators"
            element={<AdminModeratorsPage />}
          />
          <Route
            path="/administration/users"
            element={<AdminUsersPage />}
          />
          <Route
            path="/administration/statistics"
            element={<AdminStatisticsPage />}
          />
          <Route path="/missed-connections" element={<MissedConnectionsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/symbol" element={<SymbolPage />} />
          <Route path="/show-symbol" element={<ShowSymbolPage />} />
          <Route path="/signature-song" element={<SignatureSongPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/help" element={<HelpPage />} />
          <Route path="/community-rules" element={<CommunityRulesPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/imprint" element={<ImprintPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/callback" element={<CallbackPage />} />
          <Route path="/silent-renew" element={<CallbackPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Layout>
      </ProfilePictureProvider>
    </BrowserRouter>
  );
}

export default App;
